module.exports = __webpack_public_path__ + "static/media/Parents.77521d8e.png";